import * as React from 'react'
import {Theme, createStyles, withStyles, WithStyles, Icon, Chip, Button, CircularProgress} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { IDocument } from 'src/type/document';
import { acceptedDocuments } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
    root: {
      width: '100%',
      background: t.palette.common.white
    },
    QuestionDocument_error:{
        display: 'flex',
        alignItems: 'center',
        marginLeft: t.spacing.unit,
        color: 'red',
        borderRadius: '2px'
    },
    QuestionDocument_error_i: {
        marginRight: t.spacing.unit
    },
    QuestionDocument_error_clear: {
        marginLeft: t.spacing.unit,
        cursor: 'pointer'
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
  input: any;
  pattern?: string;
  onUploadFile: (f: File, callback: (uploadedFile: IDocument) => void) => void;
}


interface IStates {
    field: any;
    isUploading: boolean;
    documentUrl: string | undefined;
    documentName: string | undefined;
    errorMessage: string | undefined;
}


class DocumentField extends React.Component<IProps, IStates> {

    private fileInput: HTMLInputElement;

  state = {
    field: this.props.input.value,
    isUploading: false,
    documentUrl: this.props.input.value ? this.props.input.value.permalink : undefined,
    documentName: this.props.input.value ? this.props.input.value.name : undefined,
    errorMessage: undefined
  };

  render() {
    const {t, classes} = this.props
    const {isUploading, documentUrl, documentName} = this.state
    return (
        <div className={classes.root}>
            {isUploading &&
                <Chip 
                    label={t.downloading + '...'} 
                    icon={<CircularProgress size={30}/>}
                />
            }

            {!documentUrl && !isUploading &&
                <Button color="primary" variant="outlined" onClick={this.openFileSelection}>
                    {t.downloading}
                    <Icon>file_upload</Icon>
                    <input  style={{display: 'none'}} 
                            type="file" 
                            accept={acceptedDocuments}
                            ref={file => this.fileInput = file}
                            onChange={e => this.handleChange(e.target.files[0])}/>
                </Button>
            }

            {documentUrl && !isUploading &&
                <Chip
                    label={documentName}
                    onDelete={this.clear} 
                    onClick={() => window.open(documentUrl, '_blank')}
                    icon={<Icon>insert_drive_file</Icon>}
                />
            }

            {this.state.errorMessage &&
                <div className={classes.QuestionDocument_error}>
                    <Icon className={classes.QuestionDocument_error_i}>warning</Icon>
                        {this.state.errorMessage}
                    <Icon className={classes.QuestionDocument_error_clear} onClick={this.clearErrorMessage}>clear</Icon>
                </div>
            }
        </div>
    )
  }

  private handleChange = (file: File) => {
    const {pattern, onUploadFile} = this.props
    if (pattern && !new RegExp(pattern, 'i').test(file.name)) {
        this.setState({errorMessage: file.name + ': ' + 'Le format du document est incorrect'});
        return;
    }
    this.setState({isUploading: true});
    onUploadFile(file, this.uploadedCallback)
  };

  private uploadedCallback = (uploadedFile: IDocument) => {
    this.setState({isUploading: false, documentUrl: uploadedFile.permalink, documentName: uploadedFile.name});
    this.props.input.onChange(uploadedFile.permalink);
  };

  @autobind
  private clearErrorMessage(){
    this.setState({errorMessage: ''})
  }

  private openFileSelection = () => {
    this.fileInput.click()
  }

  private clear = () => {
    this.setState({isUploading: false, documentUrl: undefined, documentName: undefined});
    this.props.input.onChange(undefined)
  };
}

export default compose(
  withI18n,
  withStyles(styles)
)(DocumentField)



// WEBPACK FOOTER //
// ./src/shared/form/DocumentField.tsx